import { styled, TableCell, TableRow, Typography } from '@mui/material';
import { FormEvent, useState } from 'react';
import { AncillaryHourModel, EditAncillaryHourModel } from '../../lib/models/AncillaryHourModel';
import { post } from '../../lib/api';
import EditAncillaryHourModal from './Modals/EditAncillaryHourModal';
import DeleteAncillaryHourModal from './Modals/DeleteAncillaryHourModal';
// import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';
import NotesReadOnlyModal from './Modals/NotesReadOnlyModal';
import { useScreenSmallerThan } from '../../lib/hooks/breakpoint-hooks';
import IconMenu from './Modals/IconMenu';
import moment from 'moment';

export type AncillaryHoursItemProps = {
    item: AncillaryHourModel;
    setSnackbarArgument: (action: string) => void;
    setShowSnackbar: (result: boolean) => void;
    setErrored: (result: boolean) => void;
    refreshPage: () => void;
    refreshHeaderData: () => void;
};

const TableDataCell = styled(TableCell)({
    borderBottom: 'none',
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
});

export const TableIconCell = styled(TableCell)({
    padding: 0,
    borderStyle: 'none'
});

const AncillaryHourItem = ({
    item,
    setSnackbarArgument,
    setShowSnackbar,
    setErrored,
    refreshPage,
    refreshHeaderData
}: AncillaryHoursItemProps) => {
    const [ancillaryHourItem, setAncillaryHourItem] = useState(item);
    // const isLargerThanMedium = useScreenLargerThan('md');
    const isSmallerThanSmall = useScreenSmallerThan('sm');

    const onEditAncillaryHour = async (event: FormEvent, ancillaryHour: EditAncillaryHourModel) => {
        event.preventDefault();

        try {
            const result = await post(`ancillaryhours/Update`, ancillaryHour);
            result.data == null ? setErrored(true) : setErrored(false);

            if (result.data) {
                setAncillaryHourItem(result.data);
            }
            refreshPage();
            refreshHeaderData();
        } catch (error) {
            setErrored(true);
        }

        setSnackbarArgument('edit');
        setShowSnackbar(true);
    };

    const onDeleteAncillaryHour = async (event: FormEvent, id: string) => {
        event.preventDefault();

        try {
            const result = await post(`ancillaryhours/Delete`, { id });
            result.data == null ? setErrored(true) : setErrored(false);

            if (result.data) {
                setAncillaryHourItem(result.data);
            }
            refreshPage();
            refreshHeaderData();
        } catch (error) {
            setErrored(true);
        }

        setSnackbarArgument('delete');
        setShowSnackbar(true);
    };

    const formattedDate =
        ancillaryHourItem.date != null ? moment(ancillaryHourItem.date).format('MM/DD/YYYY') : '';

    return (
        <TableRow>
            {ancillaryHourItem.deletedAt === null && (
                <>
                    {/* Ancillary Hours Data */}
                    <TableDataCell>
                        <Typography
                            sx={{ fontSize: 13, fontWeight: 400, width: '15%', align: 'center' }}>
                            {formattedDate}
                        </Typography>
                    </TableDataCell>
                    <TableDataCell>
                        <Typography
                            sx={{
                                fontSize: 13,
                                fontWeight: 600
                            }}>
                            {ancillaryHourItem.activity}
                        </Typography>
                    </TableDataCell>
                    <TableDataCell>
                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                            {ancillaryHourItem.minutesTaken}
                        </Typography>
                    </TableDataCell>

                    {/* Menu Action Items */}
                    {isSmallerThanSmall ? (
                        <TableIconCell align="center">
                            <IconMenu
                                menuItems={[
                                    {
                                        text: 'Notes',
                                        icon: <NotesReadOnlyModal notes={ancillaryHourItem.notes} />
                                    },
                                    {
                                        text: 'Edit',
                                        icon: (
                                            <EditAncillaryHourModal
                                                ancillaryHour={ancillaryHourItem}
                                                onEditAncillaryHour={onEditAncillaryHour}
                                            />
                                        )
                                    },
                                    {
                                        text: 'Delete',
                                        icon: (
                                            <DeleteAncillaryHourModal
                                                id={ancillaryHourItem.id}
                                                onDeleteAncillaryHour={onDeleteAncillaryHour}
                                            />
                                        )
                                    }
                                ]}
                            />
                        </TableIconCell>
                    ) : (
                        <>
                            <TableIconCell align="center">
                                <NotesReadOnlyModal notes={ancillaryHourItem.notes} />
                            </TableIconCell>
                            <TableIconCell align="center">
                                <EditAncillaryHourModal
                                    ancillaryHour={ancillaryHourItem}
                                    onEditAncillaryHour={onEditAncillaryHour}
                                />
                            </TableIconCell>
                            <TableIconCell align="center">
                                <DeleteAncillaryHourModal
                                    id={ancillaryHourItem.id}
                                    onDeleteAncillaryHour={onDeleteAncillaryHour}
                                />
                            </TableIconCell>
                        </>
                    )}
                </>
            )}
        </TableRow>
    );
};

export default AncillaryHourItem;
